import React, { useEffect, useState } from "react";
import Plotly from "react-plotly.js";
import Select from "react-select";
import { SelectStyle } from "../../../helpers/components/SelectStyle";
import { Button } from "@material-ui/core";
import {
  getFftFilesList,
  getTrendingFftPeak,
  getFftGraphDataByFileId,
  getDownloadFftGraphDataByFileId,
} from "../../../../app/modules/auth/redux/AuthCRUD";
import { CurrentDateToGivenTimeCalculation } from "../../../helpers/components/TimeDifferenceCalculate";
import { useTheme } from "../../../layout/components/ThemeProvider/ThemeProvider";
import { useRefresh } from "../../../layout/components/ThemeProvider/RefreshButton";
import { getTimezoneAbbreviation } from "../../../../app/utils/GetTimeZoneName";
import TrendingFftForm from "./TrendingFftForm";
import moment from "moment";

const VOLTAGE_PEAK_COLOR = "#72E6FF";
const CURRENT_PEAK_COLOR = "#8C4C02";

const traceColors = {
  "Voltage Peaks": VOLTAGE_PEAK_COLOR,
  "Current Peaks": CURRENT_PEAK_COLOR,
};

const MyChart = ({
  className,
  facilityId,
  equipmentId,
  isAuthorized,
  equipment,
  isDownloadAvailable,
}) => {
  const [fftFileList, setFFtFileList] = useState([]);
  const { lightTheme } = useTheme();
  const { refresh } = useRefresh();
  const [selectedFFT, setSelectedFFT] = useState("");
  const [chartData, setChartData] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const [esaData, setEsaData] = useState();
  const [selectedPeak, setSelectedPeak] = useState("");
  const [frequencyPeak, setFrequencyPeak] = useState(0);
  const [isTrendingFFTFormLoading, setIsTrendingFFTFormLoading] =
    useState(false);

  const defaultfftPeakGraphData = [
    {
      x: [],
      y: [],
      type: "scatter",
      mode: "lines",
      fill: "tozeroy",
      fillcolor: [lightTheme ? "#06C" : "#78a9ff"],
      line: { color: lightTheme ? "#06C" : "#78a9ff", width: 3 },
    },
  ];

  const defaultTrendingfftLayout = {
    xaxis: {
      title: "Time",
      showgrid: false,
      showline: true,
      showticklabels: false,
      type: "date",
      tickformat: "%Y-%m-%d %H:%M:%S",
      titlefont: { color: lightTheme ? "black" : "white" },
      tickfont: { color: lightTheme ? "black" : "white" },
      color: lightTheme ? "black" : "white",
    },
    yaxis: {
      showline: true,
      showgrid: false,
      title: "Amplitude Avg",
      titlefont: { color: lightTheme ? "black" : "white" },
      tickfont: { color: lightTheme ? "black" : "white" },
      range: [0, 10],
    },
    legend: {
      bgcolor: "transparent",
      font: { color: lightTheme ? "black" : "white", size: 16 },
    },
    margin: {
      t: 40,
      r: 80,
      b: 80,
      l: 80,
    },
  };
  const [showDownloadLoading, setShowDownloadLoading] = useState(false);

  function maxFrequency(frequency, chunkSize = 10000) {
    let maxValue = 0;
    for (let i = 0; i < frequency.length; i += chunkSize) {
      const chunk = frequency.slice(
        i,
        Math.min(i + chunkSize, frequency.length)
      );
      const chunkMax = Math.max(...chunk.map(Math.abs));
      maxValue = Math.max(maxValue, chunkMax);
    }
    return maxValue;
  }

  const [graphData, setGraphData] = useState([
    {
      x: [],
      y: [],
      type: "line", // or 'line' for a line graph
      mode: "lines", // or 'lines' for just lines
      name: "Voltage (V)",
      // yaxis: "y1",
      hovertemplate: `<b>Freq: </b> %{x:.2f} Hz<br><b>Amplitude: </b> %{y}%<extra></extra>`,
    },
    {
      x: [],
      y: [],
      type: "line", // or 'line' for a line graph
      mode: "lines", // or 'lines' for just lines
      name: "Current (A)",
      // yaxis: "y2",
      hovertemplate: `<b>Freq: </b> %{x:.2f} Hz<br><b>Amplitude: </b> %{y}%<extra></extra>`,
    },
    {
      x: [],
      y: [],
      type: "scatter",
      mode: "markers",
      name: "Voltage Peaks",
      marker: {
        size: 8,
        color: [], // This will be an array of colors for each point
      },
      hovertemplate: `<b>Freq: </b> %{x:.2f} Hz<br><b>Amplitude: </b> %{y}%<extra></extra>`,
    },
    {
      x: [],
      y: [],
      type: "scatter",
      mode: "markers",
      name: "Current Peaks",
      marker: {
        size: 8,
        color: [], // This will be an array of colors for each point
      },
      hovertemplate: `<b>Freq: </b> %{x:.2f} Hz<br><b>Amplitude: </b> %{y}%<extra></extra>`,
    },
  ]);

  const [layout, setLayout] = useState({
    // title: "Current, Voltage vs Frequency",
    height: 550,
    margin: {
      t: 40, // Top margin (reduce space)
      r: 80, // Right margin (reduce space)
      b: 80, // Bottom margin (optional adjustment)
      l: 80, // Left margin (optional adjustment)
    },
    xaxis: {
      title: "Frequency (Hz)",
      range: [0, 10],
      showline: true,
      showgrid: false,
      showticklabels: true,
      // domain: [0.05],
      showgrid: false,
      color: lightTheme ? "black" : "white",
    },

    yaxis: {
      title: "% amplitude",
      range: [0, 100],
      showgrid: false,
      titlefont: { color: lightTheme ? "black" : "white" },
      tickfont: { color: lightTheme ? "black" : "white" },
      showline: true,
    },

    legend: {
      bgcolor: "transparent",
      font: { color: lightTheme ? "black" : "white", size: 16 },
    },
  });
  useEffect(() => {
    getFftFilesList(isAuthorized, facilityId, equipmentId)
      .then(({ data }) => {
        // return `${formattedTime}  ${getTimezoneName(timezoneOffset)}`;
        // let options = data.data.map((d) => ({

        //   label:
        //     formattedTime +
        //     getTimezoneName(timezoneOffset) +
        //     CurrentDateToGivenTimeCalculation(d.epoch * 1000),
        //   value: d.s3_uri,
        // }));
        let options = data.data.map((d) => {
          const date = new Date(d.epoch * 1000); // Convert seconds to milliseconds
          const localTime = date.toLocaleTimeString([], { hour12: false });
          const year = date.getFullYear().toString().padStart(4, "0");
          const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Note: Month is zero-indexed
          const day = date.getDate().toString().padStart(2, "0");
          const hours = date.getHours(); // Get hours in 12-hour format
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const seconds = date.getSeconds().toString().padStart(2, "0");
          const ampm = date.getHours() >= 12 ? "PM" : "AM"; // Determine AM/PM
          const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          const timezoneOffset = new Date().getTimezoneOffset();
          return {
            label:
              formattedTime +
              " " +
              // getTimezoneName(timezoneOffset) +
              getTimezoneAbbreviation(timezoneOffset) +
              " (" +
              CurrentDateToGivenTimeCalculation(d.epoch * 1000) +
              ")",
            value: d.file_id,
          };
        });

        setFFtFileList(options);
      })
      .catch(() => console.log("FFT Files not found"));
  }, [refresh]);
  const fetchGraphData = () => {
    setShowLoading(true);
    getFftGraphDataByFileId(isAuthorized, equipmentId, selectedFFT)
      .then(({ data }) => {
        let allData = [...graphData];
        allData[0].x = data.data.freq_hz;
        allData[1].x = data.data.freq_hz;
        allData[0].y = data.data.v_amp_pct;
        allData[1].y = data.data.i_amp_pct;
        allData[2].x = data.data.selected_v_peaks.freq_hz;
        allData[2].y = data.data.selected_v_peaks.v_amp_pct;
        allData[3].x = data.data.selected_i_peaks.freq_hz;
        allData[3].y = data.data.selected_i_peaks.i_amp_pct;
        if (data?.data?.esa_data) {
          setEsaData(data?.data?.esa_data);
        }

        allData[2].marker.color = Array(allData[2].x.length).fill(
          VOLTAGE_PEAK_COLOR
        );
        allData[3].marker.color = Array(allData[3].x.length).fill(
          CURRENT_PEAK_COLOR
        );

        setGraphData(allData);
        setChartData(data.data);
        setShowLoading(false);
      })
      .catch((e) => {
        console.log("FFT Files not found", e);

        setShowLoading(false);
      });
  };

  const fetchDownloadCsv = async () => {
    setShowDownloadLoading(true);
    try {
      const csvData = await getDownloadFftGraphDataByFileId(
        isAuthorized,
        equipmentId,
        selectedFFT
      );
      const blob = new Blob([csvData.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `fft_graph_data_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error fetching CSV data:", error);
    } finally {
      setShowDownloadLoading(false);
    }
  };

  useEffect(() => {
    if (Array.isArray(chartData?.freq_hz)) {
      let newLayout = { ...layout };
      newLayout.xaxis.range = [0, maxFrequency(chartData?.freq_hz)];
      setLayout(newLayout);
    }
  }, [chartData]);

  const [fftPeakGraphData, setFftPeakGraphData] = useState(
    defaultfftPeakGraphData
  );

  const [fftLayout, setfftLayout] = useState(defaultTrendingfftLayout);

  useEffect(() => {
    let newLayout = { ...layout };
    let newFftLayout = { ...fftLayout };
    let color = lightTheme ? "black" : "white";

    // For newLayout
    newLayout.xaxis.color = color;
    newLayout.yaxis.color = color;
    newLayout.yaxis.tickfont.color = color;

    if (typeof newLayout.yaxis.title === "object") {
      newLayout.yaxis.title.font.color = color;
    }

    newLayout.legend.font.color = color;
    newLayout.paper_bgcolor = lightTheme ? "#a3acd9" : "#203287";
    newLayout.plot_bgcolor = lightTheme ? "#a3acd9" : "#203287";
    setLayout(newLayout);

    // For newFftLayout
    newFftLayout.xaxis.color = color;
    newFftLayout.yaxis.color = color;
    newFftLayout.yaxis.tickfont.color = color;

    if (typeof newFftLayout.yaxis.title === "object") {
      newFftLayout.yaxis.title.font.color = color;
    }
    if (typeof newFftLayout.xaxis.title === "object") {
      newFftLayout.xaxis.title.font.color = color;
      newFftLayout.xaxis.tickfont.color = color;
    }

    newFftLayout.legend.font.color = color;
    newFftLayout.paper_bgcolor = lightTheme ? "#a3acd9" : "#203287";
    newFftLayout.plot_bgcolor = lightTheme ? "#a3acd9" : "#203287";
    setfftLayout(newFftLayout);

    let newGraphData = { ...fftPeakGraphData[0] };
    newGraphData.fillcolor = [lightTheme ? "#06C" : "#78a9ff"];
    newGraphData.line.color = lightTheme ? "#06C" : "#78a9ff";

    setFftPeakGraphData([newGraphData]);
  }, [lightTheme]);

  const handleClick = (event) => {
    const point = event.points[0];
    if (point.data.name in traceColors) {
      setSelectedPeak(point.data.name);
      setFrequencyPeak(point.x);

      const updatedGraphData = graphData.map((trace) => {
        if (trace.name in traceColors) {
          const defaultColor = traceColors[trace.name];
          const updatedMarkers = trace.marker.color.map((_, index) => {
            if (trace.name === point.data.name && index === point.pointIndex) {
              return "white";
            } else {
              return defaultColor;
            }
          });
          return {
            ...trace,
            marker: {
              ...trace.marker,
              color: updatedMarkers,
            },
          };
        }
        return trace;
      });

      setGraphData(updatedGraphData);
    }
  };

  const handleFormSubmit = async (values) => {
    setIsTrendingFFTFormLoading(true);
    const channel = selectedPeak === "Voltage Peaks" ? "v" : "i";
    const epochFrom = moment(values.timeFrom).unix();
    const epochTo = moment(values.timeTo).unix();
    const lineFrequency = esaData?.line_frequency || 1;
    const lfLower =
      (frequencyPeak - parseFloat(values.padding)) / lineFrequency;
    const lfUpper =
      (frequencyPeak + parseFloat(values.padding)) / lineFrequency;

    const body = {
      lf_upper: lfUpper,
      lf_lower: lfLower,
      epoch_from: epochFrom,
      epoch_to: epochTo,
      equipment_id: equipmentId,
    };

    getTrendingFftPeak(isAuthorized, equipmentId, body, channel)
      .then(({ data }) => {
        const updatedGraphData = data.data.map((item) => ({
          x: moment.unix(item.epoch).format("YYYY-MM-DD HH:mm:ss"),
          y: item.amplitude_avg,
        }));
        let allData = [...fftPeakGraphData];
        allData[0].x = updatedGraphData.map((item) => item.x);
        allData[0].y = updatedGraphData.map((item) => item.y);

        let newLayout = { ...fftLayout };

        if (allData[0].y.length > 0) {
          fftLayout.yaxis.range = [0, Math.max(...allData[0].y)];
        }
        fftLayout.xaxis.range = [
          moment(values.timeFrom).format("YYYY-MM-DD HH:mm:ss"),
          moment(values.timeTo).format("YYYY-MM-DD HH:mm:ss"),
        ];

        // newLayout.xaxis.title = "Time";
        newLayout.xaxis.showticklabels = true;

        setFftPeakGraphData(allData);
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setIsTrendingFFTFormLoading(false);
      });
  };

  useEffect(() => {
    if (selectedPeak == "") {
      setFrequencyPeak(0);
      setFftPeakGraphData(defaultfftPeakGraphData);
      setfftLayout(defaultTrendingfftLayout);
    }
  }, [selectedPeak]);

  return (
    <>
      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className="flex-grow-1 card-p pb-0">
          <div className=" flex-stack flex-wrap">
            <div className="me-2">
              <a
                href="#"
                className="text-dark text-hover-primary fw-bolder fs-1"
              >
                Frequency Spectrum Analysis for {equipment}
              </a>

              {/* <div className='text-muted fs-7 fw-bold'>Power KW</div> */}
            </div>

            <div className={`fw-bolder fs-3 my-4`}>
              <div className="d-inline-flex align-items-center ">
                <div className="text-muted fw-bold">Select capture</div>
                &nbsp;
                <Select
                  placeholder="FFT files"
                  styles={SelectStyle}
                  className="fs-8 ms-2 react-select-dropdown fft-files"
                  defaultValue={selectedFFT}
                  onChange={(e) => setSelectedFFT(e?.value)}
                  options={fftFileList}
                />
                &nbsp;
                {selectedFFT && (
                  <>
                    <div className="d-flex align-items-center gap-2 ">
                      <Button
                        variant="contained"
                        className="plotBtn"
                        onClick={fetchGraphData}
                        disabled={showLoading}
                      >
                        Plot
                        {showLoading && (
                          <div
                            className="spinner-border ms-2"
                            role="status"
                          ></div>
                        )}
                      </Button>
                      {isDownloadAvailable && (
                        <Button
                          variant="contained"
                          className="downloadBtn"
                          onClick={fetchDownloadCsv}
                          disabled={showDownloadLoading}
                        >
                          Download CSV
                          {showDownloadLoading && (
                            <div
                              className="spinner-border ms-2"
                              role="status"
                            ></div>
                          )}
                        </Button>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {selectedFFT && (
          <div className="card-body py-3">
            <div className="table-responsive">
              <table className="table align-middle table-row-bordered table-row-gray-100 gs-0 gy-3">
                <thead>
                  <tr className="fw-bolder text-muted bg-light">
                    <th className="ps-4 min-w-125px rounded-start">
                      Voltage (V)
                    </th>
                    <th className="min-w-125px">Current (A)</th>
                    <th className="min-w-125px">Frequency (Hz)</th>
                    <th className="min-w-125px">Power (kW / kVAr)</th>
                    <th className="min-w-125px">PF</th>
                    <th className="min-w-125px">Torque (Nm)</th>
                    <th className="min-w-125px  rounded-end">
                      % THD (Voltage / Current)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {esaData ? (
                    <>
                      <tr style={{ border: "0 0 1px 0 solid #f5f8fa" }}>
                        <td>
                          <div className="d-flex align-items-center  gap-2 ">
                            <div className="d-flex justify-content-start  flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 ms-5 fs-6 ">
                                {esaData?.voltage}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.current}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.line_frequency}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.power_kw} |
                                {esaData?.reactive_power_kvar}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.power_factor}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.torque}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="d-flex justify-content-start flex-column">
                              <span className="text-dark fw-bolder text-hover-primary mb-1 fs-6">
                                {esaData?.voltage_thd} | {esaData?.current_thd}
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      <tbody>
                        <tr>
                          <div
                            className="text-dark fs-6 text-center mt-1 ms-5 "
                            colSpan="3"
                          >
                            No ESA Data Availble
                          </div>
                        </tr>
                      </tbody>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <div className="card-body  flex-column p-0" style={{ display: "flex" }}>
          {/* begin::Stats */}
          {/* end::Stats */}

          {/* begin::Chart */}
          {/* {fftFileList.length == 0 && (
            <p className="fft-not-found">No FFT Files Found</p>
          )} */}
          <Plotly
            config={{ displaylogo: false, responsive: true }}
            data={graphData}
            layout={layout}
            style={{ width: "100%", height: 550 }} // Adjust width and height as needed
            onClick={handleClick}
          />

          {selectedPeak && (
            <>
              <div className=" trending-form-layout ">
                <TrendingFftForm
                  onSubmit={handleFormSubmit}
                  frequencyPeak={frequencyPeak}
                  setSelectedPeak={setSelectedPeak}
                  isLoading={isTrendingFFTFormLoading}
                />
                <Plotly
                  config={{ displaylogo: false, responsive: true }}
                  data={fftPeakGraphData}
                  layout={fftLayout}
                  style={{ width: "100%", height: 550 }}
                />
              </div>
            </>
          )}
          {/* end::Chart */}
        </div>
        {/* end::Body */}
      </div>
    </>
  );
};

export default MyChart;
